import environment from '../environment';

export default function makeApiRoute(url?: string): string {
   const apiUrl = environment.macroServiceUrl;
   return `${apiUrl}${url}`;
}
